import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Global from '../../../../../store/global-selectors';
import { fundAccount } from '../../providers-list/api';
import { getAccountInformation } from '../../../../../store/account-information/account-information.actions';

const useSellerLabelProviderAddFunds = (sellerLabelProviderId) => {
  const dispatch = useDispatch();
  const userId = useSelector(Global.selectUserCurrentUserId);
  return useCallback(
    (amount) => {
      return fundAccount(sellerLabelProviderId, amount, userId).finally(() => {
        dispatch(getAccountInformation());
      });
    },
    [sellerLabelProviderId, userId, dispatch],
  );
};

export default useSellerLabelProviderAddFunds;
